<template>
  <v-layout row justify-center align-center wrap class="mt-4 pt-2">

    <v-flex xs12 sm12 md4 lg6 xl6 class="mt-4 pt-2">
      <h2 class="mb-4 pl-4">Experience</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <!-- <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">JUNE 2021 -</div>
                <div class="caption font-weight-bold green--text">SEPTEMBER 2021</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>DATA SCIENTIST FOR DEPLOIEMENT PURPOSE</strong>
                <div class="caption mb-2">Diskyver</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        -->

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">NOV 2023 -</div>
                <div class="caption font-weight-bold green--text">MAY 2026</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Gameplay Developer</strong>
                <div class="caption mb-2"><a href="https://www.sportypeppers.com/">Sporty Peppers</a></div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">JUNE 2021 -</div>
                <div class="caption font-weight-bold green--text">AUG 2021</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Stage en auto-entreprenariat de création d'un studio de jeu vidéo</strong>
                <div class="caption mb-2">Incubateur d'entreprises C19</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-flex>

        <v-flex xs12 sm12 md5 lg6 xl6 class="mt-4 pt-4">
      <h2 class="mb-4 pl-4 pt-2">Education</h2>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <!-- <v-timeline-item color="green" small>
           <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">SEPT 2016 -</div>
                <div class="caption font-weight-bold green--text">PRESENT</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Ingeneer degree specialised in artificial intelligence</strong>
                <div class="caption mb-2">ISEN LILLE</div>
              </v-flex>
            </v-layout>
          </v-timeline-item> -->

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">SEP 2020 -</div>
                <div class="caption font-weight-bold green--text">APRIL 2024</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Étudiant en école d'ingénieur informatique</strong>
                <div class="caption mb-2">École National Supérieure d'Informatique pour l'Industrie et l'Entreprise (ENSIIE)</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>

          <v-timeline-item color="green" small>
            <v-layout pt-3>
              <v-flex xs4>
                <div class="caption font-weight-bold green--text">AUG 2022 -</div>
                <div class="caption font-weight-bold green--text">DEC 2022</div>
              </v-flex>
              <v-flex class="pl-2">
                <strong>Séjour d'échange niveau maîtrise en informatique</strong>
                <div class="caption mb-2">Université du Québec à Chicoutimi (UQAC)</div>
              </v-flex>
            </v-layout>
          </v-timeline-item>


        </v-timeline>
      </v-card-text>
    </v-flex>

    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Software</span>

          <span class="green--text">Skills</span>
        </h2>
        <br>
        <strong>Unity</strong>
        <v-progress-linear v-model="buffer1" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Git/Perforce</strong>
        <v-progress-linear v-model="buffer2" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <!-- <strong> Jenkins</strong>
        <v-progress-linear v-model="buffer2" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>MongoDB/Elasticsearch</strong>
        <v-progress-linear v-model="buffer3" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear> -->
      </v-flex>
      <v-flex xs12 sm12 md4 lg5 xl5 class="mx-2 pt-4">
        <h2>
          <span>Coding</span>
          <span class="green--text">Skills</span>
        </h2>
        <br>
        <strong>C#</strong>
        <v-progress-linear v-model="buffer4" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>C++/JAVA</strong>
        <v-progress-linear v-model="buffer5" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Python</strong>
        <v-progress-linear v-model="buffer6" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>.NET</strong>
        <v-progress-linear v-model="buffer7" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <strong>Angular</strong>
        <v-progress-linear v-model="buffer8" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear>
        <!-- <strong>HTML/css/js</strong>
        <v-progress-linear v-model="buffer6" :buffer-value="bufferValue" color="green" height="16"></v-progress-linear> -->
      </v-flex>
      <div class="mt-4 pt-2">
        <v-btn
          href="data/CV_Mathieu_BAESEN.pdf"
          target="_blank"
          color="green"
          dark
          large
        >
          Download Resume (French)
          <v-icon right dark>fas fa-file-download</v-icon>
        </v-btn>
      </div>

      <div class="mt-4 pt-2">
        <v-btn
          href="data/Resume_Mathieu_BAESEN.pdf"
          target="_blank"
          color="green"
          dark
          large
        >
          Download Resume (English)
          <v-icon right dark>fas fa-file-download</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  metaInfo: {
    title: 'Resume',
    titleTemplate: "%s ← Mathieu's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'description',
        content:
          'Unity Python Java C# Pytorch keras Vue'
      },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Mathieu' Space" },
      { property: 'og:site_name', content: "Mathieu' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://Mathieu.space' },
      {
        property: 'og:description',
        content:
          'Unity Python Java C# Pytorch keras Vue'
      }
    ]
  },
  data () {
    return {
      value: 0,
      buffer1: 0,
      buffer2: 0,
      buffer3: 0,
      buffer4: 0,
      buffer5: 0,
      buffer6: 0,
      buffer7: 0,
      buffer8: 0,
      bufferValue: 100,
      interval: 0
    }
  },
  mounted () {
    this.startBuffer()
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    startBuffer () {
      this.interval = setInterval(() => {
        this.buffer1 = 90
        this.buffer2 = 70
        this.buffer3 = 90
        this.buffer4 = 90
        this.buffer5 = 65
        this.buffer6 = 50
        this.buffer7 = 50
        this.buffer8 = 30
      }, 800)
    }
  }
}
</script>
<style >
</style>
